import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SectionService } from 'app/core/service/section.service';
import { Observable, switchMap, map, catchError, of } from 'rxjs';
import * as sectionActions from './section.actions';

@Injectable()
export class SectionEffects {
  constructor(private _actions$: Actions, private _sectionService: SectionService) {}

  loadSection$: Observable<Action> = createEffect(() =>
    this._actions$.pipe(
      ofType<sectionActions.LoadSections>(
        sectionActions.SectionActionTypes.LoadSections,
      ),
      switchMap(() =>
        this._sectionService.getSections().pipe(
          map(items => new sectionActions.LoadSectionsSuccess(items)),
          catchError(error =>
            of(new sectionActions.LoadSectionsFail(error)),
          ),
        ),
      ),
    ),
  );
}
